export const getApplicationsCount = (data, selector) => {
    if (!selector)
       return data.length;
    const filteredData = data.filter((item) => item.status.id === selector);
    return filteredData.length;
  };